import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import styles from './POITagRow.scss'
import {Icon} from 'common/Icon'
import p from 'prop-types'
import {togglePoiTagVisibility, removePoiTag} from 'lib/api/embeds/regional'
import {RemovePOI} from './RemovePOI'

export class POITagRow extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      showConfirm: false
    }
  }

  toggleVisibility = () => {
    const {tag, visible, togglePoiTagVisibility} = this.props
    togglePoiTagVisibility(tag, !visible)
  }

  removePoiTag = () => {
    const {tag, removePoiTag} = this.props
    removePoiTag(tag)
  }

  showConfirm = () => {
    this.setState({showConfirm: true})
  }

  hideConfirm = () => {
    this.setState({showConfirm: false})
  }

  render () {
    const {tag, visible} = this.props
    const {showConfirm} = this.state
    return (
      <li>
        <div>{tag}</div>
        <div className={styles.listControls}>
          <span className={styles.EyeToggle} onClick={this.toggleVisibility}>
            {visible ? <Fragment><Icon i='md-eye' /> On</Fragment> : <Fragment><Icon i='md-eye-off' /> Off</Fragment>}
          </span>
          <a href='#' onClick={this.showConfirm}>Remove</a>
          {showConfirm &&
            <RemovePOI
              tag={tag}
              onRequestClose={this.hideConfirm}
              onCancel={this.hideConfirm}
              onConfirm={this.removePoiTag} />}
        </div>
      </li>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {regionalEmbed} = state
  const {tag} = ownProps
  return {
    visible: regionalEmbed.getIn(['embedData', 'enabledPoiTags']).has(tag)
  }
}

const mapDispatchToProps = {
  togglePoiTagVisibility,
  removePoiTag
}

export const POITagRowContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(POITagRow)

POITagRowContainer.propTypes = {
  tag: p.string
}
